module.exports = __webpack_public_path__ + "img/kobayashi.e779b82e.png";